import styled from "styled-components";

export const ContainerForGallery = styled.div`
width: 100%;
display: grid;
row-gap: 20px;
column-gap: 15px;
padding-left: 10px;
padding-right: 10px;
grid-template-columns: repeat(4, 1fr);

@media only screen and (max-width: 768px) {
  grid-template-columns: repeat(3, 1fr);

}

@media only screen and (max-width: 560px) {
  grid-template-columns: repeat(2, 1fr);

}

 .img {
  width: 100%;
  height: 150px;
  max-height: 150px;
  overflow: hidden;
  border: 2px solid gray;
  position: relative;

  @media only screen and (max-width: 768px) {
  width: 100%;
  
}
  /* & > span { 
  position: unset !important;
  width: 100%;
  height: 100%;
  } */

.custom-image {
  /* object-fit: contain; */
   /* width: 100% !important;
   position: relative !important;
   height: 10% !important; */
   }

  
  &:hover {
    border: 2px solid #89cff0;
    cursor: zoom-in;
  }
}
`;

export const Block = styled.div`
display: inline-block;
width: 100%;
`;

export const TitleText = styled.h1`
font-family: "Helvetica bold";
text-align: center;
font-size: 3.5rem;
margin: 2.5rem auto 1rem;
/* margin-bottom: 10px; */
font-style: normal;
`;